import { Injectable } from '@angular/core';
import { ThermostatPreset, ThermostatPresetType } from '@app/modules/smart-devices/data/smart-devices.interface';
import { SmartDevicesService } from '@app/modules/smart-devices/service/smart-devices.service';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ThermostatSetupService {
  thermostatPresets$ = new BehaviorSubject<ThermostatPreset[]>([]);

  constructor(private smartService: SmartDevicesService) {}

  setThermostatPresets() {
    this.smartService.getThermostatPresets().subscribe((presets) => this.thermostatPresets$.next(presets));
  }

  thermostatPreset$(type: ThermostatPresetType) {
    return this.thermostatPresets$.pipe(
      map((presets) => presets.find((preset) => preset.type === type && preset.is_default))
    );
  }
}
